import { FileIcon, X } from 'lucide-react'
import { formatBytes } from '@/lib/format'
import { useI18n } from '@/lib/i18n'

interface FileInfoProps {
  file: File
  onRemove: () => void
}

/** Selected file summary with a remove action. */
export function FileInfo({ file, onRemove }: FileInfoProps) {
  const { t } = useI18n()

  return (
    <div className="flex items-center gap-3 rounded-xl border bg-card p-4 shadow-sm">
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
        <FileIcon className="h-5 w-5" aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{file.name}</p>
        <p className="text-xs text-muted-foreground">{formatBytes(file.size)}</p>
      </div>
      <button
        type="button"
        onClick={onRemove}
        className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        aria-label={t('commonRemoveFile', { name: file.name })}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
